export * from './src/achievements-instructors-v2-instructor-instructors.universal.js';
